import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Datetime from 'react-datetime';
import InputContainer from '../InputContainer';
import { useDateTimePicker } from './useDateTimePicker';
import { inputField } from './styles';
import 'react-datetime/css/react-datetime.css';
import { jsx as ___EmotionJSX } from "@emotion/react";

var DateTimePicker = function DateTimePicker(props) {
  var required = props.required,
      validate = props.validate,
      dateFormat = props.dateFormat,
      inputProps = props.inputProps;

  var _useDateTimePicker = useDateTimePicker(props),
      isTouched = _useDateTimePicker.isTouched,
      error = _useDateTimePicker.error,
      onBlur = _useDateTimePicker.onBlur,
      onChange = _useDateTimePicker.onChange,
      value = _useDateTimePicker.value,
      disabled = _useDateTimePicker.disabled,
      restProps = _useDateTimePicker.restProps;

  var dateTime = moment(value, dateFormat);
  var inputValue = dateTime.isValid() ? dateTime : '';
  var hasError = isTouched && error;
  var hasValidation = _isFunction(validate) || required;
  return ___EmotionJSX(InputContainer, _extends({}, props, {
    error: error,
    isTouched: isTouched
  }), ___EmotionJSX(Datetime, _extends({
    closeOnSelect: true,
    dateFormat: dateFormat,
    value: inputValue,
    onChange: onChange,
    onClose: onBlur,
    css: inputField(hasValidation, hasError, props),
    inputProps: _objectSpread({
      disabled: disabled
    }, inputProps)
  }, restProps)));
};

DateTimePicker.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  dateTimeProps: PropTypes.any,
  validate: PropTypes.func,
  label: PropTypes.string,
  horizontal: PropTypes.bool,
  required: PropTypes.bool,
  inputProps: PropTypes.object,
  dateFormat: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
var DateTimePickerRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(DateTimePicker, _extends({}, props, {
    componentRef: ref
  }));
});
DateTimePickerRef.displayName = 'DateTimePicker';
export default DateTimePickerRef;